import { render, staticRenderFns } from "./qrCounterSpentProducts.vue?vue&type=template&id=2bf66d06&"
import script from "./qrCounterSpentProducts.vue?vue&type=script&lang=js&"
export * from "./qrCounterSpentProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports